const getAuthHeaders = () => {
  const token = localStorage.getItem("token");
  if (!token) return {};
  return { Authorization: `Bearer ${token}` };
};

const getFilenameFromResponse = (response, fallbackName) => {
  const disposition = response.headers.get("content-disposition");
  if (!disposition) return fallbackName;
  const matched = disposition.match(/filename="?([^"]+)"?/i);
  return matched && matched[1] ? matched[1] : fallbackName;
};

export const downloadWithAuth = async (url, fallbackName) => {
  const response = await fetch(url, {
    headers: {
      ...getAuthHeaders(),
    },
  });

  if (!response.ok) {
    throw new Error(
      `[LỖI] Tải tệp thất bại: mã trạng thái ${response.status}, đường dẫn ${url}`,
    );
  }

  const blob = await response.blob();
  const fileUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = fileUrl;
  link.download = getFilenameFromResponse(response, fallbackName);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(fileUrl);
};
